// extracted by mini-css-extract-plugin
module.exports = {"safeDealIcon":"TransactionItem_safeDealIcon_2VZRl"};